'use client';
import { lazy, Suspense, type ComponentProps } from 'react';
export type * from "/tmp/build-287/node_modules/@eliadmin/core/src/pages/(profile)/return/page.tsx";
type Props = NonNullable<ComponentProps<typeof import("/tmp/build-287/node_modules/@eliadmin/core/src/pages/(profile)/return/page.tsx").default>>;
const Deferred = lazy(() => import("@eliadmin/route-original/fbe5aaacd4d3"));
function DeferredRoute(props: Props) { return <Suspense fallback={null}><Deferred {...props} /></Suspense>; }
export default DeferredRoute;

